/**
 * Central API bases for manager.1akb.by
 *
 * Default keeps production PHP proxies → RetailCRM.
 * Canary managers (see CANARY_MANAGER_CODES) are rewritten at runtime
 * to ORDERS_API_CANARY_BASE (orders-api own mode) via main.js interceptors.
 *
 * Full cutover: change ORDERS_API_BASE + ORDERS_SOURCE=own (explicit command only).
 */
export const ORDERS_API_BASE = 'https://1akb.by/manager/api';

/** Own orders-api (nginx → 127.0.0.1:4100). Used only for canary / cutover. */
export const ORDERS_API_CANARY_BASE = 'https://manager.1akb.by/orders-api';

/**
 * Must match orders-migration/config/feature-flags.json → CANARY_MANAGER_CODES
 * Canary (own DB → outbox → CRM):
 *  - IT Отдел (it-otdel / id 20)
 *  (Андрей Иодо временно снят — баг состава после save)
 */
export const CANARY_MANAGER_CODES = ['it-otdel', '20'];

/** Express / manager local API (tasks, filters, ws auth, etc.) */
export const MANAGER_API_BASE = 'https://manager.1akb.by';

export function isCanaryUser(user) {
  if (!user) return false;
  const code = user.symbolicCode != null ? String(user.symbolicCode).trim() : '';
  const id = user.id != null ? String(user.id) : '';
  return (
    (code && CANARY_MANAGER_CODES.includes(code)) ||
    (id && CANARY_MANAGER_CODES.includes(id))
  );
}

export function canaryManagerCode(user) {
  if (!user) return '';
  const code = user.symbolicCode != null ? String(user.symbolicCode).trim() : '';
  if (code) return code;
  return user.id != null ? String(user.id) : '';
}

export function resolveOrdersApiBase(user) {
  return isCanaryUser(user) ? ORDERS_API_CANARY_BASE : ORDERS_API_BASE;
}

export function ordersApiUrl(path = '') {
  const p = String(path || '').replace(/^\//, '');
  return p ? `${ORDERS_API_BASE}/${p}` : ORDERS_API_BASE;
}

export function managerApiUrl(path = '') {
  const p = String(path || '').replace(/^\//, '');
  return p ? `${MANAGER_API_BASE}/${p}` : MANAGER_API_BASE;
}

export default {
  ORDERS_API_BASE,
  ORDERS_API_CANARY_BASE,
  CANARY_MANAGER_CODES,
  MANAGER_API_BASE,
  isCanaryUser,
  canaryManagerCode,
  resolveOrdersApiBase,
  ordersApiUrl,
  managerApiUrl,
};
